import type { SavedCircuit } from './api.js';

const MAX_CIRCUIT_NAME_LENGTH = 80;

/** Libellé affiché (nom personnalisé ou « Circuit #id »). */
export function circuitDisplayTitle(circuit: Pick<SavedCircuit, 'id' | 'name'>): string {
  const trimmed = circuit.name?.trim();
  if (trimmed) return trimmed;
  return `Circuit #${circuit.id}`;
}

/** Option du sélecteur (DiceUI, etc.) — titre + date de création. */
export function circuitSelectOptionLabel(
  circuit: Pick<SavedCircuit, 'id' | 'name' | 'created_at'>
): string {
  const title = circuitDisplayTitle(circuit);
  const date = circuit.created_at ? new Date(circuit.created_at).toLocaleDateString('fr-FR') : '';
  return date ? `${title} (${date})` : title;
}

export function normalizeCircuitName(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  if (trimmed.length > MAX_CIRCUIT_NAME_LENGTH) {
    throw new Error(`Le nom ne peut pas dépasser ${MAX_CIRCUIT_NAME_LENGTH} caractères.`);
  }
  return trimmed;
}

export { MAX_CIRCUIT_NAME_LENGTH };
